// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"66a70a8c","121":"d5bdc0d3","163":"2047336d","251":"a57c10ef","276":"97db391e","420":"ec7a79fe","460":"649e2c7b","606":"8b58d67e","693":"53e9c6e9","767":"976312a6","848":"1543b7c0","898":"3c718482","916":"31f873b7"}[chunkId] + ".chunk.js";
};